import React from "react";
import { createRoot } from "react-dom/client";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";
import "./polyfill";
import "react-toastify/dist/ReactToastify.css";
import Application from "./startApp";
import * as serviceWorker from "./serviceWorker";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<Application />);
serviceWorker.unregister();
